import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getBuild} from '../../../../../selectors'
import type {NormalizedBuild} from '../../../../../types'
import {getBuildOvertimeInfo} from '../../../../../utils/buildOvertime'

import BuildOverviewProgress from './BuildOverviewProgress'
import type {OwnProps, StateProps} from './BuildOverviewProgress.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const build: Partial<NormalizedBuild> = getBuild(state, props.buildId) || {}
  const {leftSeconds, percentageComplete} = build['running-info'] || {}
  const elapsedSeconds = build['running-info']?.elapsedSeconds ?? 0
  const {seconds: overtimeSeconds, isOvertime} = getBuildOvertimeInfo(build)

  return {
    buildReady: build != null,
    elapsedSeconds,
    leftSeconds,
    overtimeSeconds,
    isOvertime,
    status: build.status,
    progress: percentageComplete,
  }
}

export default connect(mapStateToProps, {})(BuildOverviewProgress)
